module.exports = __webpack_public_path__ + "img/speed-meter.a9de5214.svg";